import { LegaleIncaricato } from "./legale-incaricato";
import { Attivita } from "./tipologiche/attivita-legale";
import { Cpa } from "./tipologiche/cpa";
import { Grado } from "./tipologiche/grado";
import { Iva } from "./tipologiche/iva";

export class TariffaLegale {
  id: string;
  attivita: Attivita;
  grado: Grado;
  iva: Iva;
  cpa: Cpa;
  imponibile: number;
  speseGenerali: number;
  speseEsenti: number;
  spesePiePagina: number;
  maggiorazione: number;
  totaleSpese: number;
  revisionata: boolean;

  //flagIVA: boolean ;
  //flagCPA: boolean ;
}

export class TariffaLegaleIncaricato {
  id: string;
  attivita: Attivita;
  grado: Grado;
  iva: Iva;
  cpa: Cpa;
  imponibile: number;
  speseGenerali: number;
  speseEsenti: number;
  spesePiePagina: number;
  maggiorazione: number;
  totaleSpese: number;
  revisionata: boolean;
  tariffaOriginale: TariffaLegale;
  legaleIncaricato?: LegaleIncaricato;
  mese?: any;
  anno?: any;

  static fromTariffaLegale(
    tariffaLegale: TariffaLegale
  ): TariffaLegaleIncaricato {
    const tariffaLegaleIncaricato = new TariffaLegaleIncaricato();
    tariffaLegaleIncaricato.attivita = tariffaLegale.attivita;
    tariffaLegaleIncaricato.grado = tariffaLegale.grado;
    tariffaLegaleIncaricato.iva = tariffaLegale.iva;
    tariffaLegaleIncaricato.cpa = tariffaLegale.cpa;
    tariffaLegaleIncaricato.imponibile = tariffaLegale.imponibile;
    tariffaLegaleIncaricato.speseGenerali = tariffaLegale.speseGenerali;
    tariffaLegaleIncaricato.speseEsenti = tariffaLegale.speseEsenti;
    tariffaLegaleIncaricato.spesePiePagina = tariffaLegale.spesePiePagina;
    tariffaLegaleIncaricato.maggiorazione = tariffaLegale.maggiorazione;
    tariffaLegaleIncaricato.totaleSpese = tariffaLegale.totaleSpese;
    tariffaLegaleIncaricato.revisionata = tariffaLegale.revisionata;
    tariffaLegaleIncaricato.tariffaOriginale = tariffaLegale;
    return tariffaLegaleIncaricato;
  }
}
